import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VuePapaParse from 'vue-papa-parse'
import { BootstrapVue, IconsPlugin, PaginationPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Toasted from 'vue-toasted';
import firebase from 'firebase'
import { firebaseConfig } from './firebase-config'
import vue_moment from 'vue-moment'

Vue.config.productionTip = false

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VuePapaParse)
Vue.use(PaginationPlugin)
Vue.use(vue_moment);

Vue.use(Toasted, {
  theme: "bubble", 
  position: "bottom-center", 
  fitToScreen: true,
  duration : 4000
})

firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
